// extracted by mini-css-extract-plugin
export default {"wrap":"Timer_wrap__km42J","content":"Timer_content__TgKwy"};